export const validateStatusErrorHelper = (val: boolean) => (!!val ? 'error' : '')
